var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.currentMonsters,
          "items-per-page": -1,
          dense: "",
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.name`,
              fn: function({ item }) {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { icon: "", small: "", color: "red" },
                      on: {
                        click: function($event) {
                          return _vm.removeMonster(item.keyId)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-delete-outline")])],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "readMonster", params: { id: item.keyId } },
                        title: item.name
                      }
                    },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm.hasEditPermission
        ? _c(
            "v-row",
            { staticClass: "mt-3" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "9" } },
                [
                  _c("monster-picker", {
                    attrs: { rows: "2", label: "Add New Monster..." },
                    on: { selected: _vm.monsterSelected }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "1" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        title: "Add Monster",
                        color: "success",
                        disabled: !_vm.canAddMonster
                      },
                      on: { click: _vm.addMonster }
                    },
                    [_c("v-icon", [_vm._v("mdi-plus")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }